import { InjectionToken, Injectable, Inject, ɵɵdefineInjectable, ɵɵinject, Component, Input, Pipe, NgModule } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { createAction, props, createSelector, createReducer, on, select, Store, StoreModule } from '@ngrx/store';
import { createEntityAdapter } from '@ngrx/entity';
import { createEffect, ofType, Actions, EffectsModule } from '@ngrx/effects';
import { CommonModule } from '@angular/common';
import { mergeMap, retry, tap, map, catchError, filter } from 'rxjs/operators';
import { of } from 'rxjs';
import Debug from 'debug';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/content.config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ModesoContentConfig() { }
if (false) {
    /** @type {?} */
    ModesoContentConfig.prototype.serviceId;
}
/** @type {?} */
const ModesoContentConfigService = new InjectionToken('Config');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/content.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ContentResponse() { }
if (false) {
    /** @type {?} */
    ContentResponse.prototype.content;
}
/**
 * @record
 */
function ContentDetailResponse() { }
if (false) {
    /** @type {?} */
    ContentDetailResponse.prototype.content;
}
class ContentService {
    /**
     * @param {?} http
     * @param {?} config
     */
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this.server = '';
        this.microserviceName = 'content';
        this.route = '/';
        this.detailRoute = ':id';
        this.cacheHeader = new HttpHeaders({
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
        });
        this.server = config.apiGateway;
    }
    /**
     * @return {?}
     */
    getAllContent() {
        /** @type {?} */
        const url = `${this.server}${this.microserviceName}${this.route}`;
        return this.http.get(url, { headers: this.cacheHeader });
    }
    /**
     * @param {?} id
     * @return {?}
     */
    getContentById(id) {
        /** @type {?} */
        const contentId = this.detailRoute.replace(':id', id);
        /** @type {?} */
        const url = `${this.server}${this.microserviceName}${this.route}${contentId}`;
        return this.http.get(url, { headers: this.cacheHeader });
    }
}
ContentService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
ContentService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [ModesoContentConfigService,] }] }
];
/** @nocollapse */ ContentService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ContentService_Factory() { return new ContentService(ɵɵinject(HttpClient), ɵɵinject(ModesoContentConfigService)); }, token: ContentService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ContentService.prototype.server;
    /**
     * @type {?}
     * @private
     */
    ContentService.prototype.microserviceName;
    /**
     * @type {?}
     * @private
     */
    ContentService.prototype.route;
    /**
     * @type {?}
     * @private
     */
    ContentService.prototype.detailRoute;
    /**
     * @type {?}
     * @private
     */
    ContentService.prototype.cacheHeader;
    /**
     * @type {?}
     * @private
     */
    ContentService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    ContentService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/actions/content.actions.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const getAllContent = createAction('[Content] getAllContent');
/** @type {?} */
const onAllContentLoadedSuccessfully = createAction('[Content] all content loaded successfully', props());
/** @type {?} */
const onAllContentLoadingFailed = createAction('[Content] all content loading failed', props());
/** @type {?} */
const getContentById = createAction('[Content] getContentById', props());
/** @type {?} */
const onContentByIdLoadedSuccessfully = createAction('[Content] contentById loaded successfully', props());
/** @type {?} */
const onContentByIdLoadingFailed = createAction('[Content] contentById loading failed', props());
/**
 * @record
 * @template T
 */
function ActionWithPayload() { }
if (false) {
    /** @type {?} */
    ActionWithPayload.prototype.payload;
}
/**
 * @record
 */
function ActionWithContentId() { }
if (false) {
    /** @type {?} */
    ActionWithContentId.prototype.contentId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/reducers/content.reducer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const featureKey = 'modesoContentMicroservice';
// State Declarations - START
/** @type {?} */
const adapter = createEntityAdapter({
    selectId: selectContentId,
    sortComparer: sortById
});
/**
 * @param {?} a
 * @return {?}
 */
function selectContentId(a) {
    return a.contentId;
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function sortById(a, b) {
    return a.contentId.localeCompare(b.contentId);
}
/**
 * @record
 */
function FeatureState() { }
/**
 * @record
 */
function AppState() { }
if (false) {
    /** @type {?} */
    AppState.prototype.modesoContentMicroservice;
}
// State Declarations - END
// Selectors Declarations - START
/** @type {?} */
const selectFeature = (/**
 * @param {?} state
 * @return {?}
 */
(state) => state.modesoContentMicroservice);
const ɵ0 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state;
/** @type {?} */
const selectFeatureContent = createSelector(selectFeature, (ɵ0));
const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
/** @type {?} */
const selectContentEntities = createSelector(selectFeatureContent, selectEntities);
/** @type {?} */
const selectContentAllEntities = createSelector(selectFeatureContent, selectAll);
const ɵ1 = /**
 * @param {?} entities
 * @param {?} props
 * @return {?}
 */
(entities, props) => {
    return entities[props.id];
};
/** @type {?} */
const selectEntitiesByID = createSelector(selectContentEntities, (ɵ1));
const ɵ2 = /**
 * @param {?} entities
 * @param {?} props
 * @return {?}
 */
(entities, props) => {
    return entities.filter((/**
     * @param {?} content
     * @return {?}
     */
    content => content.collection === props.filter));
};
/** @type {?} */
const selectEntitiesByFilter = createSelector(selectContentAllEntities, (ɵ2));
// Selectors Declarations - END
// Reducer Declarations - START
/** @type {?} */
const initialState = adapter.getInitialState();
const ɵ3 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ4 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => {
    return adapter.addMany(action.payload, Object.assign({}, state));
}, ɵ5 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ6 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ7 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => {
    return adapter.addOne(action.payload, Object.assign({}, state));
}, ɵ8 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state));
/** @type {?} */
const contentReducer = createReducer(initialState, on(getAllContent, (ɵ3)), on(onAllContentLoadedSuccessfully, (ɵ4)), on(onAllContentLoadingFailed, (ɵ5)), on(getContentById, (ɵ6)), on(onContentByIdLoadedSuccessfully, (ɵ7)), on(onContentByIdLoadingFailed, (ɵ8)));
/**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
function reducer(state, action) {
    return contentReducer(state, action);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/content/content.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ContentComponent {
    /**
     * @param {?} store
     */
    constructor(store) {
        this.store = store;
        this.requestDataFromBackend = true;
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        if (this.contentId === undefined) {
            console.log('contentId is not defined');
            return;
        }
        else {
            this.content$ = this.store.pipe(select(selectEntitiesByID, { id: this.contentId }));
        }
        if (this.requestDataFromBackend) {
            this.store.dispatch(getContentById({ contentId: this.contentId }));
        }
    }
}
ContentComponent.decorators = [
    { type: Component, args: [{
                selector: 'lidl-lib-content-fe',
                template: "<div class=\"lidl-lib-content-fe\">\r\n    <h1>{{(content$ | async)?.title}}</h1>\r\n    <p>{{(content$ | async)?.text}}</p>\r\n</div>\r\n\r\n\r\n\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
ContentComponent.ctorParameters = () => [
    { type: Store }
];
ContentComponent.propDecorators = {
    contentId: [{ type: Input }],
    requestDataFromBackend: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ContentComponent.prototype.contentId;
    /** @type {?} */
    ContentComponent.prototype.requestDataFromBackend;
    /** @type {?} */
    ContentComponent.prototype.content$;
    /** @type {?} */
    ContentComponent.prototype.store;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/content-list/content-list.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ContentListComponent {
    /**
     * @param {?} store
     */
    constructor(store) {
        this.store = store;
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        if (this.filter === undefined) {
            console.log('filter is not defined');
            return;
        }
        else {
            this.contents$ = this.store.pipe(select(selectEntitiesByFilter, { filter: this.filter }));
        }
        this.store.dispatch(getAllContent());
    }
}
ContentListComponent.decorators = [
    { type: Component, args: [{
                selector: 'lidl-lib-content-fe-list',
                template: "<div class=\"lidl-lib-content-fe-list col-lg-12 col-xs-12\">\r\n    <lidl-lib-content-fe *ngFor=\"let content of contents$ |\u00A0async\"\r\n        [requestDataFromBackend]=\"false\"\r\n        [contentId]=\"content.contentId\">\r\n    </lidl-lib-content-fe>\r\n</div>\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
ContentListComponent.ctorParameters = () => [
    { type: Store }
];
ContentListComponent.propDecorators = {
    filter: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ContentListComponent.prototype.filter;
    /** @type {?} */
    ContentListComponent.prototype.contents$;
    /** @type {?} */
    ContentListComponent.prototype.store;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/providers/contentStore.provider.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug = Debug('modeso:modeso-content:ContentStoreProvider');
class ContentStoreProvider {
    /**
     * @param {?} store
     */
    constructor(store) {
        this.store = store;
        this.observers = new Set();
    }
    /**
     * @return {?}
     */
    loadContents() {
        this.store.dispatch(getAllContent());
    }
    // to be used if needed
    // public getContentForKey(key: string): Observable<ContentModel> {
    //   return this.store.pipe(
    //     select(fromReducers.selectEntitiesByID, { id: key }),
    //     map((content: ContentModel) => {
    //       debug('got ' + key);
    //       debug(content);
    //       if (content) {
    //         debug('return ' + content.title);
    //         return content;
    //       } else {
    //         return undefined;
    //       }
    //     }));
    // }
    /**
     * @param {?} contents
     * @return {?}
     */
    notifyObservers(contents) {
        debug('noify observers');
        debug(this.observers.size);
        this.observers.forEach((/**
         * @param {?} observer
         * @return {?}
         */
        observer => {
            observer.setInjectedText(contents);
        }));
    }
}
ContentStoreProvider.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ContentStoreProvider.ctorParameters = () => [
    { type: Store }
];
/** @nocollapse */ ContentStoreProvider.ngInjectableDef = ɵɵdefineInjectable({ factory: function ContentStoreProvider_Factory() { return new ContentStoreProvider(ɵɵinject(Store)); }, token: ContentStoreProvider, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ContentStoreProvider.prototype.observers;
    /** @type {?} */
    ContentStoreProvider.prototype.store;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/effects/content.effects.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ContentEffects {
    /**
     * @param {?} actions$
     * @param {?} service
     * @param {?} contentStoreProvider
     */
    constructor(actions$, service, contentStoreProvider) {
        this.actions$ = actions$;
        this.service = service;
        this.contentStoreProvider = contentStoreProvider;
        this.loadAllContent$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(getAllContent.type), mergeMap((/**
         * @return {?}
         */
        () => {
            return this.service.getAllContent()
                .pipe(retry(1), tap((/**
             * @param {?} response
             * @return {?}
             */
            (response) => {
                // send to dependecies
                this.contentStoreProvider.notifyObservers(response.content);
            })), map((/**
             * @param {?} response
             * @return {?}
             */
            response => (onAllContentLoadedSuccessfully({ payload: response.content })))), catchError((/**
             * @param {?} error
             * @return {?}
             */
            (error) => of(onAllContentLoadingFailed({ payload: error })))));
        })))));
        this.errorOnLoadAllContent$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(onAllContentLoadingFailed.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleOnLoadAllContentErrors(action.payload))))), { dispatch: false });
        this.loadContentById$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(getContentById.type), mergeMap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => {
            console.log(`content should be loaded for ${action.contentId}`);
            return this.service.getContentById(action.contentId)
                .pipe(retry(1), map((/**
             * @param {?} response
             * @return {?}
             */
            response => (onContentByIdLoadedSuccessfully({ payload: response.content })))), catchError((/**
             * @param {?} error
             * @return {?}
             */
            (error) => of(onContentByIdLoadingFailed({ payload: error })))));
        })))));
        this.errorOnLoadContentById$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(onContentByIdLoadingFailed.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleOnLoadAllContentErrors(action.payload))))), { dispatch: false });
    }
    /**
     * @param {?} error
     * @return {?}
     */
    handleOnLoadAllContentErrors(error) {
        console.log(error);
        return error;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    log(data) {
        console.log(data);
    }
}
ContentEffects.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ContentEffects.ctorParameters = () => [
    { type: Actions },
    { type: ContentService },
    { type: ContentStoreProvider }
];
if (false) {
    /** @type {?} */
    ContentEffects.prototype.loadAllContent$;
    /** @type {?} */
    ContentEffects.prototype.errorOnLoadAllContent$;
    /** @type {?} */
    ContentEffects.prototype.loadContentById$;
    /** @type {?} */
    ContentEffects.prototype.errorOnLoadContentById$;
    /**
     * @type {?}
     * @private
     */
    ContentEffects.prototype.actions$;
    /**
     * @type {?}
     * @private
     */
    ContentEffects.prototype.service;
    /**
     * @type {?}
     * @private
     */
    ContentEffects.prototype.contentStoreProvider;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/content.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug$1 = Debug('modeso:modeso-content:ContentPipe');
class ContentPipe {
    /**
     * @param {?} store
     */
    constructor(store) {
        this.store = store;
        debug$1('ContentPipe constructed');
    }
    /**
     * @param {?} key
     * @param {?} selector
     * @return {?}
     */
    transform(key, selector) {
        return this.store.pipe(select(selectEntitiesByID, { id: key }), map((/**
         * @param {?} content
         * @return {?}
         */
        (content) => {
            if (content) {
                return content.text[selector];
            }
            else {
                return undefined;
            }
        })), filter((/**
         * @param {?} text
         * @return {?}
         */
        (text) => text !== undefined)));
    }
}
ContentPipe.decorators = [
    { type: Pipe, args: [{ name: 'content' },] }
];
/** @nocollapse */
ContentPipe.ctorParameters = () => [
    { type: Store }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    ContentPipe.prototype.store;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/content.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModesoContentModule {
    /**
     * @param {?} config
     * @return {?}
     */
    static forRoot(config) {
        return {
            ngModule: ModesoContentModule,
            providers: [
                ContentService,
                {
                    provide: ModesoContentConfigService,
                    useValue: config
                }
            ]
        };
    }
}
ModesoContentModule.decorators = [
    { type: NgModule, args: [{
                declarations: [ContentComponent, ContentListComponent, ContentPipe],
                providers: [ContentService],
                imports: [
                    CommonModule,
                    StoreModule.forFeature(featureKey, reducer),
                    EffectsModule.forFeature([ContentEffects])
                ],
                exports: [ContentComponent, ContentListComponent, ContentPipe]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/content.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ContentModel {
    /**
     * @param {?} contentId
     * @param {?} title
     * @param {?} text
     * @param {?} html
     * @param {?} lang
     * @param {?} collection
     * @param {?} imageSrc
     */
    constructor(contentId, title, text, html, lang, collection, imageSrc) {
        this.contentId = contentId;
        this.title = title;
        this.text = text;
        this.html = html;
        this.lang = lang;
        this.collection = collection;
        this.imageSrc = imageSrc;
    }
}
if (false) {
    /** @type {?} */
    ContentModel.prototype.contentId;
    /** @type {?} */
    ContentModel.prototype.title;
    /** @type {?} */
    ContentModel.prototype.text;
    /** @type {?} */
    ContentModel.prototype.html;
    /** @type {?} */
    ContentModel.prototype.lang;
    /** @type {?} */
    ContentModel.prototype.collection;
    /** @type {?} */
    ContentModel.prototype.imageSrc;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: modeso-giftcardshop-lib-content-fe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ContentComponent, ContentListComponent, ContentModel, ContentPipe, ContentService, ContentStoreProvider, ModesoContentConfigService, ModesoContentModule, adapter, featureKey, initialState, reducer, selectAll, selectContentAllEntities, selectContentEntities, selectContentId, selectEntities, selectEntitiesByFilter, selectEntitiesByID, selectFeature, selectFeatureContent, selectIds, selectTotal, sortById, getAllContent as ɵa, onAllContentLoadedSuccessfully as ɵb, onAllContentLoadingFailed as ɵc, getContentById as ɵd, onContentByIdLoadedSuccessfully as ɵe, onContentByIdLoadingFailed as ɵf, ContentEffects as ɵg };
